import "@fontsource/barlow-condensed/600.css";
import "@fontsource/barlow-condensed/700.css";
import "@fontsource-variable/instrument-sans";
import "./styles.css";

import { mountDashboard } from "./mount";

mountDashboard(document, window.location.pathname);
